export default "__VITE_ASSET__Bg3YDRSp__"